import { render, staticRenderFns } from "./accommodations.vue?vue&type=template&id=a1d81e6c&scoped=true"
import script from "./accommodations.vue?vue&type=script&lang=js"
export * from "./accommodations.vue?vue&type=script&lang=js"
import style0 from "./accommodations.vue?vue&type=style&index=0&id=a1d81e6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d81e6c",
  null
  
)

export default component.exports